import { QueryClientProvider } from "@tanstack/react-query";
import { Suspense, lazy } from "react";
import { queryClient } from "../../query";
import { SvixCustomerContext } from "../svix/context";

const SvixWebhookLogsComponent = lazy(() => import("./component"));

export default function SvixWebhookLogs(props: {
  svixCustomerContext: SvixCustomerContext;
}) {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <QueryClientProvider client={queryClient}>
        <SvixCustomerContext.Provider value={props.svixCustomerContext}>
          <SvixWebhookLogsComponent
            appId={props.svixCustomerContext.app_id}
            token={props.svixCustomerContext.token}
          />
        </SvixCustomerContext.Provider>
      </QueryClientProvider>
    </Suspense>
  );
}
